import $ from 'jquery';
import Vue from 'vue';
import axios from 'axios';
// import { saveAs } from 'file-saver';
import PageHeader from '@/components/PageHeader';
import PageFooter from '@/components/PageFooter';
import NavInner from '@/components/NavInner';
import NavUserOrgs from '@/components/org-admin/NavUserOrgs';
import NavUserOrgPage from '@/components/org-admin/NavUserOrgPage';
import OrgAdminSum from '@/components/org-admin/OrgAdminSum';
import OrgAdminDates from '@/components/org-admin/inputs/OrgAdminDates';
import OrgAdminObjTypes from '@/components/org-admin/inputs/OrgAdminObjTypes';
import OrgAdminObjEvents from '@/components/org-admin/inputs/OrgAdminObjEvents';
import OrgAdminObjs from '@/components/org-admin/inputs/OrgAdminObjs';
import OrgAdminUsers from '@/components/org-admin/inputs/OrgAdminUsers';
import OrgAdminUserEvents from '@/components/org-admin/inputs/OrgAdminUserEvents';
import OrgAdminDealsContTypes from '@/components/org-admin/inputs/OrgAdminDealsContTypes';

export default {

  components: {
    PageHeader,
    PageFooter,
    NavInner,
    NavUserOrgs,
    NavUserOrgPage,
    OrgAdminSum,
    OrgAdminDates,
    OrgAdminObjTypes,
    OrgAdminObjEvents,
    OrgAdminObjs,
    OrgAdminUsers,
    OrgAdminUserEvents,
    OrgAdminDealsContTypes,
  },

  data() {
    return {
      tableData: null,
      reportsLoaded: 0,
      showNoResultsMsg: true,
      filter: {},
      activeRequest: { dataKey: '', url: '', params: '' },
      pager: {
        total: 0,
        curPage: 1,
        pageSize: null,
      },
      vaultText: '',
    };
  },

  created() {
    this.pager.pageSize = this.filter.limit;
    this.filter = Object.assign({}, this.filterDefaults);
  },

  computed: {
    filterLimit() {
      return this.filter.limit;
    },
  },

  watch: {
    $route() {
      this.fetchData();
    },
    reportsLoaded() {
      if (this.reportsLoaded === this.reportsTotal) {
        Vue.$loading.off();
        if (!this.tableData.length && this.showNoResultsMsg) {
          this.$alert(`В базе системы IPUniversity нет данных,
          соответствующих критериям поиска.`);
        }
      }
    },
    filterLimit() {
      this.pager.pageSize = this.filter.limit;
    },
  },

  methods: {

    getParams() {
      const params = {};
      Object.keys(this.filter).forEach((key) => {
        const el = this.filter[key];
        if (key === 'limit') {
          params[key] = el;
          return;
        }
        if (key === 'offset') {
          params[key] = (this.pager.curPage - 1) * this.filter.limit;
          return;
        }
        if (Array.isArray(el)) {
          if (el.length > 0) {
            params[key] = el;
          }
        } else if (el) {
          params[key] = el;
        }
      });
      return $.param(params, true);
    },

    timeToDate(time) {
      return new Date(time * 1000).toLocaleDateString('ru-RU');
    },

    round(val) {
      return Math.round(val * 100) / 100;
    },

    clearReportForm() {
      this.$message('Форма очищена.');
      this.filter = Object.assign({}, this.filterDefaults);
    },

    fio(a) {
      const fio = [];
      if (a.Surname) fio.push(a.Surname);
      if (a.Name) fio.push(a.Name);
      if (a.Patronymic) fio.push(a.Patronymic);
      return fio.join(' ');
    },

    print(format) {
      const data = Object.assign({ format }, this.activeRequest);
      axios.post('organizations/print', data, { responseType: 'blob' }).then((r) => {
        const url = window.URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement('a');
        link.href = url;
        const filename = `ipuniversity.${format}`;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      });
    },

  },

};



// WEBPACK FOOTER //
// ./src/components/layouts/org-admin/UserOrgLayoutMixin.js